<template>
  <div class="cmp-catalog-product_groups-product_groups_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddProductGroupsClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" >
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
       
      </div>
    </div>
    <div class="dt-page--body">
      <div class="ut-fh-48" >
        <NTable
          id="catalog-product_groups-product_group_list"
          class="h1"
          :config="tableConfig"
          :headers="productGroupHeaders"
          :items="list"
          :loadingFlag="loadingFlag"
           @scrollnext="onListScroll"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr
              :class="{
                selected: selectedRow(item),
              }"
              @click="onProductGroupClicked(item)"
              :title="$t('click_to_see_product_groups')"
            >
              <td v-bind="tdcon('product_group')">
                <span class="txtov" :title="item['product_group_name1']">
                  {{ item["product_group_name1"] }}
                </span>
              </td>
              <td v-bind="tdcon('catalog_no')">
                <span class="txtov" :title="item['catalog_nos']">{{
                  item["catalog_nos"]
                }}</span>
              </td>
              <td v-bind="tdcon('options')">
                <img
                  src="static/icons/delete.svg"
                  @click.stop="(e) => onDeleteProductGroup(item)"
                  class="dt-icon v5 s2 ut-center"
                  alt
                />
              </td>
            </tr>
          </template>
        </NTable>
      </div>
      <!-- <div class="dt-page--body--bottom-bar ut-flex ut-jend">
        <button class="dt-button v5 s8" @click="refresh">{{$t('refresh')}}</button>
      </div> -->
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="productGroupsDetailsFlag"
      @closed="onCloseProductGroupsDetails"
    >
      <ProductGroupsSidewindow />
    </Sidewindow>

    <ModalContainer :modalKey="'addProductGroup'" :width="'420'">
      <AddProductGroups @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { LDTHost } from "@/dt-plugins/sidewindow";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import InputField from "@plugins/text-field/input-field";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { CatalogStoreNamespace as storeNS } from "../../store";
import { createModalMixin } from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import { subscribeSubject, sendMail, openWindow } from "../../../../utility";
import {
  getProductGroupsDetailsSelectable,
  productGroupsLDTRoutes,
} from "../../router/routes";
import { HttpClient } from "../../../../services/http/http-client";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  showNotification,
  showError,
} from "../../../../dt-plugins/notification/notification.service";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { product_groupsCatalogActions } from "../../store/product_groups/actions";
import { product_groupsCatalogGetters } from "../../store/product_groups/getters";
import AddProductGroups from "./add-product_groups";
import ProductGroupsSidewindow from "./product_groups-sidewindow";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { actions } from "../../../../../scripts/blueprints/module/store/actions";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
const listLength = 30;

const LDTConfig = {
  entityName: "product_group",
  ldtRoutes: productGroupsLDTRoutes,
  detailsSelectableFunction: getProductGroupsDetailsSelectable,
  primaryKey: "product_group_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.Product_groupDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.Product_groupDetails.FETCH.SINGLE,
};

export default {
  components: {
    ModalContainer,
    NTable,
    InputField,
    LDTHost,
    Sidewindow,
    AddProductGroups,
    ProductGroupsSidewindow,
  },
  mixins: [createLDTHost(LDTConfig), 
  createFetchListMixin(ActionTypes.Product_groupsList.FETCH.ALL, 50, {
      searchable: true,
      scrollable: true,
    }), 
    createModalMixin("addProductGroup")],
  mounted: async function () {
    // this.fetchList();

    // subscribeSubject(this, this.scrollSubject$, (scrollTop) => {
    //   if (this.invoice_list_start_from == this.startFrom) {
    //     this.startFrom += listLength;
    //     this.fetchListNext();
    //   }
    // });
  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      getProductGroupsDetailsSelectable: getProductGroupsDetailsSelectable,

      countries: [],
      groups: [],

      startRow: 0,

      selectedInvoiceProject: null,
      selectedUser: null,
      selectedStatuses: [],

      startFrom: 0,
      scrollSubject$: new Subject(),

      LDTHostConfig: {
        itemKey: "invoice",
      },

      invoice_setstat: null,
      selectedClickedInvoice: null,
      hoverFlag: false,
      hoverPayments: [],

      // NEW
      selectedClickedProductGroup: null,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, product_groupsCatalogGetters),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.product_groupsList?.product_groups || [];
    },
    productGroupHeaders: function () {
      return [
        createTableHeader("product_group", { f: 0.5, fw: 700 }),
        createTableHeader("catalog_no"),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    productGroupsDetailsFlag: function () {
      return childOfOrEqualDetails(productGroupsLDTRoutes, this.$route);
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
      };
    },
    paginatedFilter: function () {
      return {};
    },
  },
  methods: {
    ...mapActionObject(storeNS, product_groupsCatalogActions),
    refresh: function () {
      this.fetchListNext();
    },
    defaultBasicFilter() {
      return {
        searchString: undefined,
      };
    },
    onAddProductGroupsClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_group",
        },
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAdded: function (productGroupsData) {
      // console.log("response ", productGroupsData);
      this[ActionTypes.Product_groupsList.SET.ALL](productGroupsData);
      this.onDialogCancelled();
    },
    onCloseProductGroupsDetails: function () {
      this.selectedClickedProductGroup = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: productGroupsLDTRoutes.names.list,
        });
      });
    },
    selectedRow: function (product_group) {
      // return (
      //   this.selectedClickedProductGroup && this.selectedClickedProductGroup["product_group_id"] == product_group["product_group_id"]
      // );
      return false;
    },


    onProductGroupClicked: function (productGroup) {
      // console.log("product Groups Details ", productGroup);
      this.selectedClickedProductGroup = productGroup;
      this.$router.push({
        name: productGroupsLDTRoutes.names.tab,
        params: {
          product_group_id: productGroup.product_group_id,
          tab: "overview",
        },
      });
    },

    onDeleteProductGroup: async function (item) {
      const confirmationResult = await confirmDelete(
        "Product Group",
        item.product_group_name1
      );
      if (confirmationResult === "OK") {
        console.log("Delete");
        this[ActionTypes.Product_groupsList.DELETE.SINGLE](item);
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-product_groups-product_groups_list {
  .dt-page--body {
    --offset: 169px;
  }
  // .catalog-product_groups-product_group_list {
  //   --ntable-height: calc(100vh - 176px);
  // }
  td.options {
    div {
      display: flex;
      flex-direction: row;
      img {
        flex: 1;
      }
      .loading-icon-container {
        flex: 1;
        .loading-icon {
          max-width: 15px;
          max-height: 15px;
          margin-top: 10px;
          margin-left: 16px;
        }
      }
    }
  }

  td .phone-icon {
    display: none;
  }
  td .phone-no {
    display: inherit;
  }

  @media (min-width: 1281px) {
  }
  @media (min-width: 1025px) and (max-width: 1280px) {
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  }
  @media (min-width: 481px) and (max-width: 767px) {
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .dt-page--top-bar {
      .right-space {
        flex: 10;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .dt-page--top-bar > div {
      margin: 0 0 0 10px;
    }
  }
  @media (min-width: 320px) and (max-width: 375px) {
  }

  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 1;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
  //         border-radius: 30px;
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
